import React from 'react';
import { SignUp } from '@clerk/clerk-react';

const SignUpPage: React.FC = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-background">
      {/* Clerk's SignUp component provides a ready-made registration flow */}
      <SignUp path="/sign-up" routing="path" signInUrl="/login" />
    </div>
  );
};

export default SignUpPage; 